function shuffleArray(array) {
    for (var i = array.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = array[i];
        array[i] = array[j];
        array[j] = temp;
    }
}

export default class RandomTemplate {

	static init(){
        try {
            document.querySelectorAll('[data-choose-random-template]').forEach((parent) => {
                const templates = [...parent.querySelectorAll('script[type="text/template"]')];
                const key = parent.dataset.chooseRandomTemplate ?? 'unknown';

                const previous = localStorage?.getItem(key) ?? null;

                const filtered = templates.filter(template => template.dataset.id != previous);
                if(filtered.length <= 0){
                    return;
                }

                shuffleArray(filtered);

                const chosenTemplate = filtered[0];
                const current = chosenTemplate.dataset.id;
                localStorage?.setItem(key, current);

                parent.innerHTML = chosenTemplate.innerHTML;

            });
        } catch(e){
            console.error(e);
        }
	}
}